import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import logo from "./../assets/images/logo.svg"
import { withRouter } from "react-router-dom"
import "../assets/styles/clave_unica/cu.css"
import LoginMail from "../components/index/LoginMail"
import LoginOptions from "../components/index/LoginOptions"
import Loader from "../components/shared/Loader"
import { useUser } from "../context/UserProvider"

const Inicio = ({loadingUser, history}) => {
  const {user} = useUser()
  const [showLogin, setShowLogin] = useState(false)
  
  useEffect(() => {
    if(user){
      history.push("/votaciones")
        console.log("En index el user existe", user)
    }else{
              console.log("En index el user no existe", user)

    }
  }, [user])

	return (
		<Container>
			<Row>
				<Col className="text-center mt-5">
					<img src={logo} className="img-responsive" alt="logoUla" width={130} /> <br />
					<span className="title-ula">UNIVERSIDAD DE LOS LAGOS</span>
					<span className="subtitle-ula">Sistema de Votaciones</span>
					<p className="mt-2">
						Bienvenidos al sistema de Votaciones de la Universidad de Los Lagos.
						Puede acceder desde aquí a todas las elecciones a las que usted tiene derecho
						a participar.
					</p>
				</Col>
			</Row>
			{loadingUser ? (
				<Loader />
			) : showLogin ? (
				<LoginMail setShowLogin={setShowLogin} />
			) : (
				<LoginOptions setShowLogin={setShowLogin} />
			)}

		</Container>
	)
}

export default withRouter(Inicio)
